<template>
  <q-layout view="lHh Lpr lFf">
    <q-header elevated style="left: 0 !important">
      <q-toolbar class="col-8 bg-grey-1 text-black">
        <div class="municipi">
          <div class="municipi__title"><span class="text-red-10">@</span>ctivAMB</div>
          <hr style="height: 30px" />

          <div v-if="showAytoSection" class="brand">
            <img
              class="brand__image"
              :src="require(`./assets/static/municipis/Logos_Ajuntaments_260x260-${keycloak?.idTokenParsed?.idMunicipi[0]}.png`)"
            />
            {{ "Ajuntament de " + keycloak.idTokenParsed.nameMunicipi[0] }}
          </div>
        </div>
        <q-space></q-space>
        <q-btn @click="resetProjectList()" no-caps label="Projectes" class="q-ml-sm" style="background-color: #f44336; color: white" />
        <q-btn-dropdown flat color="#000000" no-caps :label="`Hola, ${keycloak.idTokenParsed.name}`">
          <div class="row no-wrap q-pa-md">
            <div class="column items-center">
              <q-btn @click="logout" flat label="Tancar sessió" size="md" />
            </div>
          </div>
        </q-btn-dropdown>
      </q-toolbar>
    </q-header>

    <VistaProjecte />

    <q-page-container>
      <q-page>
        <div :id="mfePlist"></div>
        <div :id="mfeMemoria"></div>
        <div :id="mfeExecucio"></div>
        <div :id="mfeJustificacioTecnica"></div>
        <div :id="mfeJustificacioEconomica"></div>
        <div :id="mfeFinalitzar"></div>
        <div :id="mfeImpacte"></div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import { ref, getCurrentInstance, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import VistaProjecte from "./views/VistaProjecte.vue";
import { useStore } from "vuex";

export default {
  name: "LayoutDefault",
  components: {
    VistaProjecte,
  },
  setup() {
    const internalInstance = getCurrentInstance();
    const keycloak = internalInstance?.appContext?.config?.globalProperties?.$keycloak;
    const route = useRoute();
    const path = computed(() => route.path);
    const store = useStore();

    const logout = () => {
      internalInstance.appContext.config.globalProperties.$keycloak.logout();
    };

    const resetProjectList = () => {
      // goToProjectList();
      internalInstance.appContext.config.globalProperties.$router.push({ path: "/" });
      store.commit("RESET_STATE");
    };

    const goToProjectList = () => {
      internalInstance.appContext.config.globalProperties.$router.push({
        path: `${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_PLIST}/`,
      });
    };

    const showAytoSection = computed(() => {
      const validRoles = ["RES", "TEC"];
      const role = internalInstance.appContext.config.globalProperties.$keycloak.idTokenParsed?.idRole;
      return role.some((role) => validRoles.includes(role));
    });

    onMounted(() => {
      goToProjectList();
    });

    return {
      mfePlist: ref(process.env.VUE_APP_MICRO_VUE3_CONTAINER_PLIST),
      path,
      leftDrawerOpen: ref(false),
      logout,
      goToProjectList,
      showAytoSection,
      mfeMemoria: ref(process.env.VUE_APP_MICRO_VUE3_CONTAINER_MEMORIA),
      mfeExecucio: ref(process.env.VUE_APP_MICRO_VUE3_CONTAINER_EXECUCIO),
      mfeJustificacioTecnica: ref(process.env.VUE_APP_MICRO_VUE3_CONTAINER_JUSTIFICACIO_TECNICA),
      mfeJustificacioEconomica: ref(process.env.VUE_APP_MICRO_VUE3_CONTAINER_JUSTIFICACIO_ECONOMICA),
      mfeFinalitzar: ref(process.env.VUE_APP_MICRO_VUE3_CONTAINER_FINALITZAR),
      mfeImpacte: ref(process.env.VUE_APP_MICRO_VUE3_CONTAINER_IMPACTE),
      resetProjectList,
      keycloak,
    };
  },
};
</script>

<style lang="scss">
#app {
  font-family: "Source Sans Pro" !important;
}

.municipi {
  display: flex;
  align-items: center;

  &__title {
    font-size: 1.2rem;
    margin-right: 15px;
  }

  .brand {
    height: 3vh;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 15px;
    &__image {
      filter: invert(1);
      height: 3vh;
      object-fit: contain;
      margin-right: 10px;
    }
  }
}
</style>
